module.exports = __webpack_public_path__ + "static/media/ChairLeg_Before.66193608.jpg";